import { render, staticRenderFns } from "./AddressListRight.vue?vue&type=template&id=785518a4&scoped=true"
import script from "./AddressListRight.vue?vue&type=script&lang=js"
export * from "./AddressListRight.vue?vue&type=script&lang=js"
import style0 from "./AddressListRight.vue?vue&type=style&index=0&id=785518a4&prod&lang=css"
import style1 from "./AddressListRight.vue?vue&type=style&index=1&id=785518a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785518a4",
  null
  
)

export default component.exports